module.exports = __webpack_public_path__ + "static/media/26UNRWA10.bcb4ba2d.jpg";